import { Component } from 'vue';
import AccessRequest from '../assets/infuse-icons/access-request.svg?component';
import Analytics from '../assets/infuse-icons/analytics.svg?component';
import BatchJobs from '../assets/infuse-icons/batch-jobs.svg?component';
import AuditLog from '../assets/infuse-icons/audit-log.svg?component';
import ChargePoint from '../assets/infuse-icons/chargingpoint.svg?component';
import Connections from '../assets/infuse-icons/connections.svg?component';
import CreditCardBlank from '../assets/infuse-icons/credit-card-blank.svg?component';
import Dashboard from '../assets/infuse-icons/dashboard.svg?component';
import Groups from '../assets/infuse-icons/groups.svg?component';
import IdCard from '../assets/infuse-icons/id-card.svg?component';
import Locations from '../assets/infuse-icons/locations.svg?component';
import NotificationBell from '../assets/infuse-icons/notification-bell.svg?component';
import Operators from '../assets/infuse-icons/operators.svg?component';
import Planner from '../assets/infuse-icons/planner.svg?component';
import Pools from '../assets/infuse-icons/pools.svg?component';
import Power from '../assets/infuse-icons/power.svg?component';
import Properties from '../assets/infuse-icons/properties.svg?component';
import Sessions from '../assets/infuse-icons/sessions.svg?component';
import Settings from '../assets/infuse-icons/settings.svg?component';
import SmartChargingNetwork from '../assets/infuse-icons/smart-charging-network.svg?component';
import Subscriptions from '../assets/infuse-icons/subscriptions.svg?component';
import Synchronisation from '../assets/infuse-icons/synchronisation.svg?component';
import Tariffs from '../assets/infuse-icons/tariffs.svg?component';
import TokenGroups from '../assets/infuse-icons/token-groups.svg?component';
import Transactions from '../assets/infuse-icons/transactions.svg?component';
import Upload from '../assets/infuse-icons/upload.svg?component';
import User from '../assets/infuse-icons/user.svg?component';
import Installer from '../assets/infuse-icons/installer.svg?component';
import Cube from '../assets/infuse-icons/cube.svg?component';
import Cubes from '../assets/infuse-icons/cubes.svg?component';
import MapLocation from '../assets/infuse-icons/map-location.svg?component';
import Lock from '../assets/infuse-icons/lock.svg?component';
import FolderGear from '../assets/infuse-icons/folder-gear.svg?component';
import Tag from '../assets/infuse-icons/tag.svg?component';
import Eye from '../assets/infuse-icons/eye.svg?component';

export function getNavigationIcon(icon: string): Component {
  switch (icon) {
    case 'access-request':
      return AccessRequest;
    case 'analytics':
      return Analytics;
    case 'audit-log':
      return AuditLog;
    case 'batch-jobs':
      return BatchJobs;
    case 'charging-sessions':
      return Transactions;
    case 'charging-stations':
      return ChargePoint;
    case 'connections':
      return Connections;
    case 'dashboard':
      return Dashboard;
    case 'eye':
      return Eye;
    case 'groups':
      return Groups;
    case 'locations':
      return Locations;
    case 'installer':
      return Installer;
    case 'notifications':
      return NotificationBell;
    case 'operators':
      return Operators;
    case 'planner':
      return Planner;
    case 'pools':
      return Pools;
    case 'properties':
      return Properties;
    case 'rfids':
      return CreditCardBlank;
    case 'permissions':
      return Lock;
    case 'role':
      return IdCard;
    case 'sessions':
      return Sessions;
    case 'settings':
      return Settings;
    case 'smart-charging-network':
      return SmartChargingNetwork;
    case 'subscription':
      return Subscriptions;
    case 'synchronisation':
      return Synchronisation;
    case 'tariffs':
      return Tariffs;
    case 'token-groups':
      return TokenGroups;
    case 'upload':
      return Upload;
    case 'user':
      return User;
    case 'cube':
      return Cube;
    case 'cubes':
      return Cubes;
    case 'map-location':
      return MapLocation;
    case 'folder-gear':
      return FolderGear;
    case 'tag':
      return Tag;
    default:
      return Power;
  }
}
